import React from "react"
import SchemaDetail from "@/components/SchemaDetail"

export default function SchemaDetailView() {
  return <SchemaDetail />
}
